export const theadNormal = {backgroundColor:"#b2aea3", textAlign: "center",verticalAlign: "middle"}